import { Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "./components/ToastContainer";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Layout } from "./components/Layout";
import { LoginPage } from "./pages/LoginPage";
import { MenuPage } from "./pages/MenuPage";
import { DishEditPage } from "./pages/DishEditPage";
import { OrdersPage } from "./pages/OrdersPage";
import { AddOrderPage } from "./pages/AddOrderPage";
import { PromoCodesPage } from "./pages/PromoCodesPage";
import { EmployeesPage } from "./pages/EmployeesPage";
import { BattleshipPage } from "./pages/BattleshipPage";
import { TreasurePage } from "./pages/TreasurePage";
import { AboutPage } from "./pages/AboutPage";
import { SafeCrackingPage } from "./pages/SafeCrackingPage";
import { SafeCrackingPublicPage } from "./pages/SafeCrackingPublicPage";
import { useAuth } from "./hooks/useAuth";

export const AppRoutes = () => {
  const { isAuthenticated, isLoading } = useAuth();

  // Для публичных страниц не показываем загрузку auth
  const isPublicRoute = window.location.pathname === '/treasure-hunt' || window.location.pathname === '/login' || window.location.pathname === '/safe-cracking-game';

  if (isLoading && !isPublicRoute) {
    return (
      <div className="min-h-screen bg-background-100 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 bg-primary-500 rounded-lg flex items-center justify-center mx-auto mb-4 animate-pulse">
            <span className="text-white font-bold text-3xl">R</span>
          </div>
          <p className="text-text-secondary">Загрузка...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <ToastContainer />
      <Routes>
        {/* Публичные роуты */}
        <Route
          path="/login"
          element={
            isAuthenticated ? <Navigate to="/orders" replace /> : <LoginPage />
          }
        />
        <Route path="/treasure-hunt" element={<TreasurePage />} />
        <Route path="/safe-cracking-game" element={<SafeCrackingPublicPage />} />

        {/* Защищённые роуты с общим Layout */}
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Navigate to="/orders" replace />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/orders/add" element={<AddOrderPage />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/menu/dish/:id" element={<DishEditPage />} />
          <Route path="/promo-codes" element={<PromoCodesPage />} />
          <Route path="/employees" element={<EmployeesPage />} />
          <Route
            path="/treasure-hunt-generation"
            element={<BattleshipPage />}
          />
          <Route path="/safe-cracking" element={<SafeCrackingPage />} />
          <Route path="/about" element={<AboutPage />} />
        </Route>

        {/* Перенаправление на заказы для несуществующих роутов */}
        <Route path="*" element={<Navigate to="/orders" replace />} />
      </Routes>
    </>
  );
};
